module.exports = __webpack_public_path__ + "static/img/113.bd1219c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200525/113.jpg
// module id = sXsW
// module chunks = 0